export const renderInquirySummaryCell = (reason: string) => {
  const summary = reason.trim();
  if (summary.length <= 140) {
    return <span className='inquiry-summary-text'>{summary}</span>;
  }
  return (
    <details className='inquiry-summary-details'>
      <summary>
        <span className='inquiry-summary-preview'>{summary}</span>
        <span className='inquiry-summary-toggle inquiry-summary-toggle--closed'>View full inquiry</span>
        <span className='inquiry-summary-toggle inquiry-summary-toggle--open'>Hide full inquiry</span>
      </summary>
      <div className='inquiry-summary-full'>{summary}</div>
    </details>
  );
};

export const formatPhoneNumber = (
  countryCode?: string | null,
  phoneNumber?: string | null,
  extension?: string | null
) => {
  const countryCodeDigits = countryCode?.replace(/\D/g, '') ?? '';
  const phoneDigits = phoneNumber?.replace(/\D/g, '') ?? '';
  const extensionDigits = extension?.replace(/\D/g, '') ?? '';
  const formattedPhone =
    countryCodeDigits === '1' && phoneDigits.length === 10
      ? `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(3, 6)}-${phoneDigits.slice(6)}`
      : `${countryCodeDigits ? `+${countryCodeDigits} ` : ''}${phoneDigits}`;
  return extensionDigits ? `${formattedPhone} ext. ${extensionDigits}` : formattedPhone;
};

export const formatRequestType = (requestType: string) => requestType.replace(/-/g, '\u2011');
